import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useDialog } from '@zep/dialog';
import { Button, Stack } from '@zep/ui';
import { isMobileDevice } from '@zep/utils';
import { OperationType } from '../../../../types';
import { usePlanSpaceDetailContext } from '../plan';
import S from './AppliedPlan.module.scss';
export const PlanButtons = () => {
  const {
    spacePlan,
    readySpacePlans,
    subscription
  } = usePlanSpaceDetailContext();

  // 구독취소 버튼이 숨겨져야하는 조건
  const shouldHideCancel = isMobileDevice() || spacePlan?.status === 'EXPIRED' || subscription?.requestedAction === 'UNSUBSCRIBE' || spacePlan?.planType === 'FREE' || spacePlan?.operationType === OperationType.일시납 || spacePlan?.operationType === OperationType.커스텀_일시납 ||
  // 24.09.03 현재 readySpacePlans엔 일시납 플랜들만 존재함. 추후 정기결제 플랜들도 존재할 수 있는 경우를 고려하였음
  readySpacePlans.length > 0 && readySpacePlans.every(item => item.readySpacePlan.operationType === OperationType.일시납 || item.readySpacePlan.operationType === OperationType.커스텀_일시납);
  return <Stack direction={'row'} gap={8} className={S.button_wrapper} data-sentry-element="Stack" data-sentry-component="PlanButtons" data-sentry-source-file="PlanButtons.tsx">
      <ContactButton data-sentry-element="ContactButton" data-sentry-source-file="PlanButtons.tsx" />
      {!shouldHideCancel && <CancelButton />}
    </Stack>;
};
const ContactButton = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <Button as={'a'} target={'_blank'} href={t('subscription:plans.contact.channelTalkLink')} variant={'sub'} size={'xs'} data-sentry-element="Button" data-sentry-component="ContactButton" data-sentry-source-file="PlanButtons.tsx">
      {t('subscription:SpaceDetail.menuManage.buttonPaymentContact')}
    </Button>;
};
const CancelButton = () => {
  const dialog = useDialog();
  const {
    t
  } = useTranslation(['subscription']);
  const {
    spacePlan,
    readySpacePlans
  } = usePlanSpaceDetailContext();
  const unableCancelSubscription = () => {
    dialog.confirm({
      title: t('subscription:plans.unableCancelPlan.title'),
      content: t('subscription:plans.unableCancelPlan.content'),
      confirmText: t('subscription:payment.alertFailPay.buttonContact'),
      confirmAction: async () => {
        window.open(t('subscription:plans.contact.channelTalkLink'), '_blank');
      },
      cancelText: t('subscription:plans.unableCancelSubscription.closeModal')
    });
  };
  if (!spacePlan && readySpacePlans.length // 현재 플랜이 없고 예정된 플랜만 존재한다면
  ) {
    // 구독 취소 불가
    return <Button size={'xs'} variant="sub" transparent onClick={unableCancelSubscription}>
        {t('subscription:unsubscribe.unsubscribeButton.text')}
      </Button>;
  }
  return <Link href={`/me/spaces/${spacePlan?.spaceHashId}/plan/cancel`} passHref legacyBehavior prefetch={false} data-sentry-element="Link" data-sentry-component="CancelButton" data-sentry-source-file="PlanButtons.tsx">
      <Button size={'xs'} variant="sub" transparent data-sentry-element="Button" data-sentry-source-file="PlanButtons.tsx">
        {t('subscription:unsubscribe.unsubscribeButton.text')}
      </Button>
    </Link>;
};